export default {

    generic : {
        create: 'create',
        edit: 'edit',
        delete: 'delete'
    },

    /*
     * Administrator Events
     */
    admin : {
        reset_password: 'pwd_reset',
        activate_account: 'activate_account',
        lock_account: 'lock_account',
        user_register: 'user_register',
    },

    /*
     * Farmer Events
     */
    farmers : {
        assign_fbo: 'assign_fbo'
    },

    users : {
        change_password: 'pwd_change',
        profile_update: 'edit_profile',
        account_locked: 'account_locked',
        logout: 'logout',
        login: 'login'
    },

    /*
     * FBO Events
     */
    fbo : {
        addedFarmer: 'farmer_add',
        removeFarmer: 'remove_farmer',
        clearFarmers: 'clear_farmers'
    },

    /*
     * Media Specific Events
     */
    media : {
        update: 'update',
        clear: 'clear',

    },

    /*
     * Transaction Events
     */
    transactions : {
        status_changed: 'status_changed'
    },

    tractor_requests : {
        request_paid: "request_paid",
        request_begin: "request_begin",
        request_assigned: 'request_assigned',
        request_completed: 'request_completed',
        request_released: 'request_released',
    }

}


// WEBPACK FOOTER //
// ./src/common/NotificationEvents.js